/* eslint-disable @typescript-eslint/no-use-before-define */
import {
  ControlValueAccessor,
  FormControl,
  FormControlName,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import { Store } from "@ngrx/store";

import {
  Input,
  Component,
  forwardRef,
  HostListener,
  ViewChild,
  ElementRef,
  OnInit,
} from "@angular/core";
import { REGEX } from "../../../config/app.config";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { iconsLibrary } from "../../../../theme/constants";
import { EInputMediaStyleType } from "../../../data-types/input-media-style.enum";
import { IAppState } from "../../../store/state/app.state";
import { showAlertAction } from "../../../store/actions/alert.action";
import { TranslateService } from "@ngx-translate/core";
@Component({
  selector: "cowing-input-media",
  templateUrl: "./cowing-input-media.component.html",
  styleUrls: ["./cowing-input-media.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CowingInputMediaComponent),
      multi: true,
    },
  ],
})
export class CowingInputMediaComponent implements ControlValueAccessor, OnInit {
  @HostListener("document:click", ["$event"])
  onClick(event) {}

  @Input("value") value: string;
  @Input("required") required: boolean = false;
  @Input("validateInput") validateInput: boolean = true;
  @Input("isForm") isForm: boolean = false;
  @Input("control") control: FormControl = null;
  @Input("acceptPhoto") acceptPhoto: boolean;
  @Input("name") name: string = "inputFile";
  @Input("inputStyle") inputStyle: string = EInputMediaStyleType.normal;

  @ViewChild("input") input: ElementRef;
  keyboard: any;
  toggledShowPassword = false;
  valid = false;
  checked: boolean;
  msg = "";
  status = "";
  url;
  private internalInputChange;
  constructor(
    private sanitizer: DomSanitizer,
    private _store: Store<IAppState>,
    private translate: TranslateService
  ) {}
  ngOnInit() {
    // setTimeout(() => {
    if (this.control.value) {
      console.log(this.control.value);
      if (typeof this.control.value == "string") {
        this.url = this.control.value;
      } else {
        this.readUrl(this.control.value);
      }
    }
    // }, 3000);
  }
  public onInputChange($event?: any) {
    if ($event) {
      this.value = $event.target.value;
      this.internalInputChange(this.value);
    }
  }

  public get getIcon() {
    return `${iconsLibrary[this.acceptPhoto ? "photoActive" : "videoActive"]}`;
  }

  public handleFileInput(event) {
    if (event.target.files && event.target.files[0]) {
      let maxAllowedSize = 5.5 * 1024 * 1024;
      if (!this.acceptPhoto) {
        maxAllowedSize = 95 * 1024 * 1024;
      }
      if (event.target.files[0].size > maxAllowedSize) {
        this._store.dispatch(
          showAlertAction({
            payload: {
              message: this.acceptPhoto
                ? this.translate.instant("general.imageLarge")
                : this.translate.instant("general.videoLarge"),
              title: this.translate.instant("general.caution"),
              type: "error",
            },
          })
        );
        event.target.value = "";
      } else {
        const file = (event.target as HTMLInputElement).files[0];
        this.readUrl(file);
      }
    }
  }

  readUrl(file: any) {
    this.control.setValue(file);
    this.control.updateValueAndValidity();
    const reader = new FileReader();
    reader.onload = () => {
      this.url = reader.result as string;
    };
    reader.readAsDataURL(file);
    this.control.markAsDirty();
  }

  writeValue(value: any): void {
    if (value) {
      this.value = value;
    }
  }
  registerOnChange(fn: any): void {
    this.internalInputChange = fn;
  }
  registerOnTouched(fn: any): void {
    //throw new Error("Method not implemented.");
  }
  setDisabledState?(isDisabled: boolean): void {
    // throw new Error("Method not implemented.");
  }

  onChangeKeyboard(input) {
    this.value = input;
    this.internalInputChange(this.value);
    // this.validateFormat();
  }

  onKeyPress(button) {}
  deleteVideo() {
    // this.control.setValue(null);
  }
  public get getCloseIcon() {
    return `${iconsLibrary.editSvg}`;
  }
}
